import React, { useContext, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { UserContext } from '../../contexts/user'
import { ReactComponent as Logo } from '../icons/logo.svg'
import { PRODUCTS, PROFILE } from '../../routes'

import './header.css'

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const { data, logout } = useContext(UserContext)

  function handleMenuMobile() {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <nav
      className={`navbar background-horizontal-gradient ${
        (isMobileMenuOpen && 'is-fixed-top') || ''
      }`}
    >
      <div className="container is-fluid">
        <div className="navbar-brand">
          <Link to={PRODUCTS} className="navbar-item">
            <Logo className="header-logo" />
          </Link>
          <div
            className="merchant-name"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <i
              className="fas fa-grip-lines-vertical"
              style={{ fontSize: '23px', color: '#ffffff', margin: '0 40px' }}
            ></i>

            <span style={{ fontSize: '20px', color: '#ffffff' }}>
              {data.user.merchant.name}
            </span>
          </div>
          <span
            role="button"
            aria-label="menu"
            aria-expanded="false"
            onClick={handleMenuMobile}
            className={`navbar-burger ${
              (isMobileMenuOpen && 'is-active') || ''
            }`}
          >
            <span className="has-background-white" aria-hidden="true" />
            <span className="has-background-white" aria-hidden="true" />
            <span className="has-background-white" aria-hidden="true" />
          </span>
        </div>
        <div
          className={`navbar-menu menu-mobile ${
            (isMobileMenuOpen && 'is-active') || ''
          }`}
        >
          <div className="navbar-start is-hidden-desktop">
            <aside className="menu px-4">
              {data.user.profile.menuDetails.map(
                ({ id, type, children, url }) => {
                  return (
                    <React.Fragment key={id}>
                      <p
                        className="menu-label"
                        style={{ fontSize: '17px', fontWeight: 'bold' }}
                      >
                        {type === 'Seguridad' ? (
                          <i
                            className="fas fa-shield-alt"
                            style={{
                              fontSize: '22px',
                              color: '#1844B6',
                              marginRight: '10px',
                            }}
                          ></i>
                        ) : <div></div> && type === 'Catalogo' ? (
                          <i
                            className="fas fa-th-large"
                            style={{
                              fontSize: '22px',
                              color: '#1844B6',
                              marginRight: '10px',
                            }}
                          ></i>
                        ) : <div></div> && type === 'Reportes' ? (
                          <i
                            className="fas fa-scroll"
                            style={{
                              fontSize: '22px',
                              color: '#1844B6',
                              marginRight: '10px',
                            }}
                          ></i>
                        ) : <div></div> && type === 'Dashboard' ? (
                          <i
                            className="fas fa-tachometer-alt"
                            style={{
                              fontSize: '22px',
                              color: '#1844B6',
                              marginRight: '10px',
                            }}
                          ></i>
                        ) : (
                          <div></div>
                        )}
                        {type}
                      </p>
                      <ul className="menu-list">
                        {children.map(element => {
                          return (
                            <li key={element.type} className="ml-5">
                              <NavLink
                                to={url + element.url}
                                onClick={handleMenuMobile}
                                activeClassName="is-active"
                                isActive={(match, location) => {
                                  return location.pathname.includes(
                                    !!match && match.url,
                                  )
                                }}
                              >
                                {element.type}
                              </NavLink>
                            </li>
                          )
                        })}
                      </ul>
                    </React.Fragment>
                  )
                },
              )}
            </aside>
          </div>
          <div className="navbar-end">
            <div className="navbar-item has-dropdown is-hoverable">
              <div className="is-flex is-align-items-center is-justify-content-center has-text-white">
                <div className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center mr-3">
                  <span>{`${data.user.firstName || ''} ${
                    data.user.lastName || ''
                  }`}</span>
                </div>
                <span className="icon">
                  <i className="fas fa-user-circle is-size-3 ml-4" />
                </span>
                <span className="icon">
                  <i className="fas fa-chevron-down is-size-7 ml-5" />
                </span>
              </div>
              <div className="navbar-dropdown cursor-pointer">
                <Link to={PROFILE} className="navbar-item">
                  Mi cuenta
                </Link>
                <hr className="navbar-divider" />
                <Link to="/login" className="navbar-item" onClick={logout}>
                  Cerrar sesión
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}
